import { ReactNode } from 'react';

import { Card, Header, Subtitle, Title } from './styles';

interface SectionCardProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function SectionCard({
  title,
  subtitle,
  action,
  children,
}: SectionCardProps): JSX.Element {
  return (
    <Card>
      <Header>
        <div>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
        {action}
      </Header>
      {children}
    </Card>
  );
}
